import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../context/AuthContextProvider";
import { ANALYTICS_EVENTS, logAnalyticsEvent } from "../../analytics";
import nopreview from "../../assets/images/others/no-preview.png";
import { BlankPreview } from "../../components/BlankPreview";
import { Icon } from "@iconify/react";
import moment from "moment";
import { toast } from "sonner";
import {
  useGetCollection,
  deleteCollection,
  // useGetAssignees,
} from "../../api/collection";
import SelectCenter from "../../components/SelectCenter.jsx";
import FilterSelect from "../../components/FilterSelect.jsx";
import { RequireAuth } from "../../RequireAuth.jsx";
import CenterType from "../../components/CenterType.jsx";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Menu,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  TextField,
  InputAdornment,
  Popover,
  Divider,
  Grid,
  Skeleton,
  Radio,
  Avatar,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

// MUI X Date pickers (Free)
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CustomFilters from "./../../components/Filters/Filters";
import { debounce } from "lodash";
import TypeIcon from "../../components/Reusables/HubSpokeIcon/TypeIcon.jsx";

function CollectionTasks() {
  const { user: authUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [args, setArgs] = useState({ page, limit });
  const { collections, isLoading, pagination } = useGetCollection(args);
  const [collectionData, setCollectionData] = useState(() =>
    Array.isArray(collections) ? collections : [],
  );
  // const { assignees, isLoading: assigneesLoading } = useGetAssignees(args);
  // const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const listRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const rowHeight = 60;
  const skeletonCount = Math.ceil(window.innerHeight / rowHeight);

  useEffect(() => {
    if (!collections) return;

    setCollectionData((prev) => {
      if (page === 1) return collections;

      const existingIds = new Set(prev.map((c) => c._id));
      const newItems = collections.filter((c) => !existingIds.has(c._id));
      return [...prev, ...newItems];
    });

    // decide hasMore AFTER API returns
    if (pagination?.totalPages) {
      setHasMore(page < pagination.totalPages);
    } else {
      setHasMore(collections.length === limit);
    }

    // setIsLoadingMore(false);
  }, [collections, page]);

  //  const hasMore = (() => {
  //   if (pagination?.totalPages) {
  //     return page < pagination.totalPages;
  //   }
  //   return Array.isArray(collections) && collections.length === limit;
  // })();

  const handleScroll = (e) => {
    const target = e.currentTarget;
    const threshold = 120;
    const reachedBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - threshold;
    if (reachedBottom && !isLoading && hasMore) {
      // setIsLoadingMore(true);
      const nextPage = page + 1;
      setPage(nextPage);
      setArgs((prev) => ({ ...prev, page: nextPage, limit }));
    }
  };

  const handleFilter = (data) => {
    setPage(1);
    setCollectionData([]);
    // setIsLoadingMore(false);
    setArgs({ ...data, page: 1, limit });
  };

  const handleDelete = async (id, index) => {
    const updatedData = [...collectionData];
    updatedData.splice(index, 1);
    setCollectionData(updatedData);

    try {
      const args = { id };
      const response = await deleteCollection(args);

      if (response.success) {
        toast.success(response.message);
      } else {
        toast.error(response.message || "Failed to delete collection.");
      }
    } catch (e) {
      console.error("Delete error:", e);
      toast.error("An error occurred while deleting.");
    }
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuIndex, setMenuIndex] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const handleMenuOpen = (event, index) => {
    setAnchorEl(event.currentTarget);
    setMenuIndex(index);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuIndex(null);
  };

  const renderIcon = (type) => {
    if (type?.toLowerCase() === "hub") {
      return (
        <Icon
          icon="mingcute:hospital-fill"
          width="15"
          height="15"
          style={{ color: "var(--app-text)" }}
        />
      );
    }
    if (type?.toLowerCase() === "spoke") {
      return (
        <Icon
          icon="icon-park-solid:hospital-three"
          width="15"
          height="15"
          style={{ color: "var(--app-text)" }}
        />
      );
    }
    return null;
  };
  function truncateWithEllipsis(text = "", maxLength = 15) {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength - 3) + "...";
  }

  return (
    <>
      <Helmet>
        <title>Spandan - Test Collections</title>
      </Helmet>

      <Box className="main-wrappers">
        <Box
          className="page-wrapper"
          sx={{
            pb: "10px",
            
            fontFamily: "Figtree",
            height: "100vh",
          }}
        >
          <Box className="content">
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                fontSize: "20px",
                fontFamily: "Figtree",
                mb: 2,
              }}
            >
              Test Collections
            </Typography>
            <Filter handleFilter={handleFilter} />
            <CustomFilters
              onApply={(filters) => {
                setPage(1);
                setCollectionData([]);
                setArgs({
                  page: 1,
                  limit,
                  searchText: filters.searchText,
                  status: filters.status.join(","),
                  assignedTo: filters.assignees.join(","),
                  platform: filters.platform.join(","),
                  dateFrom: filters.dateFrom,
                  dateTo: filters.dateTo,
                  centerIds: JSON.stringify(
                    filters.spokeIds.length ? filters.spokeIds : filters.hubIds,
                  ),
                  sorting: filters.sort,
                });
              }}
              component="collection"
            />

            {isLoading && collectionData.length === 0 ? (
              // Skeleton
              <Box sx={{ mt: 2 }}>
                {Array.from({ length: skeletonCount }).map((_, idx) => (
                  <Skeleton
                    key={idx}
                    variant="rounded"
                    height={50}
                    animation="wave"
                    sx={{ mb: 2 }}
                  />
                ))}
              </Box>
            ) : collectionData.length > 0 ? (
              <TableContainer className="app-table-card"
                component={Paper}
                sx={{
                  mt: 2,
                  maxHeight: "70vh",
                  overflowY: "auto",
                  fontFamily: "Figtree",
                }}
                onScroll={handleScroll}
                ref={listRef}
              >
                <Table
                  stickyHeader
                  sx={{
                    borderCollapse: "separate",
                    borderSpacing: "0 10px",
                    "& th": {
                      borderBottom: "none",
                      fontWeight: 800,
                      fontSize: "15px",
                      color: "#A3A3A3",
                      py: 1.5,
                    },
                    "& td": {
                      borderBottom: "none",
                      fontSize: "15px",
                      py: 1.5,
                      px: 2,
                      color: "var(--app-text)",
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {[
                        "COLL. ID",
                        "CENTRE",
                        "PATIENT",
                        "CREATED ON",
                        "RECEIVED ON",
                        "ASSIGNED TO",
                        "STATUS",
                        "ACTIONS",
                      ].map((heading, idx) => (
                        <TableCell
                          key={idx}
                          align={heading === "ACTIONS" ? "right" : "left"}
                          sx={{
                            backgroundColor: "var(--app-surface-2)",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "15px",
                              fontWeight: 800,
                              fontFamily: "Figtree",
                            }}
                          >
                            {heading}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {collectionData.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          border: "none",
                          backgroundColor: "var(--app-surface)",
                          borderRadius: "8px",
                          fontFamily: "Figtree",
                          "& > *:first-of-type": {
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                          },
                          "& > *:last-of-type": {
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                          },
                        }}
                      >
                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                          #{item.collection_id}
                        </TableCell>

                        <TableCell title={item.center_details?.name}>
                          <Box display="flex" alignItems="center">
                            <TypeIcon type={item.center_details?.centerType} />
                            <Typography
                              ml={1}
                              sx={{
                                whiteSpace: "nowrap",
                                fontFamily: "Figtree",
                              }}
                            >
                              {truncateWithEllipsis(
                                item.center_details?.name || "",
                                12,
                              )}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            maxWidth: "160px", // keep truncation but allow natural alignment
                          }}
                        >
                          <Box
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <Link
                              to={`/patients/${item.user_details?._id}`}
                              style={{
                                color: "var(--app-text)",
                                textDecoration: "underline",
                                fontFamily: "Figtree",
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                              title={`${item.user_details?.firstName || ""} ${
                                item.user_details?.lastName || ""
                              }`}
                            >
                              {truncateWithEllipsis(
                                `${item.user_details?.firstName || ""} ${
                                  item.user_details?.lastName || ""
                                }`,
                                17,
                              )}
                            </Link>
                          </Box>
                        </TableCell>

                        <TableCell>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "15px",
                              fontFamily: "Figtree",
                            }}
                          >
                            {moment(item.createdAt).format("DD/MM/YYYY")},{" "}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{
                              fontSize: "14px",
                              fontFamily: "Figtree",
                            }}
                          >
                            {moment(item.createdAt).format("hh:mm a")}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          {item.collected_on ? (
                            <>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "15px" }}
                              >
                                {moment(item.collected_on).format("DD/MM/YYYY")}
                                ,
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ fontSize: "14px" }}
                              >
                                {moment(item.collected_on).format("hh:mm a")}
                              </Typography>
                            </>
                          ) : (
                            "-"
                          )}
                        </TableCell>

                        <TableCell>
                          <Box display="flex" alignItems="center">
                            <Avatar
                              src={
                                item?.assign_to?.primaryUserProfilePicture ||
                                undefined
                              }
                              variant="circular"
                              sx={{
                                width: 26,
                                height: 26,
                                borderRadius: "50px",
                              }}
                            >
                              {!item?.assign_to?.primaryUserProfilePicture &&
                                (item?.assign_to
                                  ? `${item.assign_to.firstName?.[0] ?? ""}${
                                      item.assign_to.lastName
                                        ? item.assign_to.lastName[0]
                                        : ""
                                    }`
                                  : "N")}
                            </Avatar>

                            <Typography ml={1} sx={{ whiteSpace: "nowrap" }}>
                              {truncateWithEllipsis(
                                item?.assign_to
                                  ? `${item.assign_to.firstName ?? ""} ${
                                      item.assign_to.lastName ?? ""
                                    }`
                                  : "--",
                                12,
                              )}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell>
                          <Chip
                            label={
                              item.status === "REQUESTED"
                                ? "Pending"
                                : item.status === "COLLECTED"
                                  ? "Collected"
                                  : item.status === "INTERPRETATION_SENT"
                                    ? "Interpretation Sent"
                                    : "Completed"
                            }
                            sx={{
                              width: "86px",
                              fontWeight: "700",
                              fontSize: "12px",
                              borderRadius: "6px",
                              border:
                                item.status === "REQUESTED"
                                  ? "1px solid #E4841A12"
                                  : item.status === "COLLECTED"
                                    ? "1px solid #34853012"
                                    : item.status === "INTERPRETATION_SENT"
                                      ? "1px solid #01579B12"
                                      : "1px solid #2E7D3212",
                              color:
                                item.status === "REQUESTED"
                                  ? "#E4841A"
                                  : item.status === "COLLECTED"
                                    ? "#348530"
                                    : item.status === "INTERPRETATION_SENT"
                                      ? "#01579B"
                                      : "#2E7D32",
                              backgroundColor:
                                item.status === "REQUESTED"
                                  ? "#FFECD6"
                                  : item.status === "COLLECTED"
                                    ? "#DAF4E1"
                                    : item.status === "INTERPRETATION_SENT"
                                      ? "#E3F2FD"
                                      : "#E8F5E9",
                            }}
                          />
                        </TableCell>

                        <TableCell
                          align="center"
                          sx={{ border: "none", py: 2 }}
                        >
                          <RequireAuth
                            role={["b2b", "b2b-member", "b2b-admin"]}
                            permission={
                              item.status === "REQUESTED"
                                ? "canManageRequests"
                                : "canViewReports"
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={(e) => handleMenuOpen(e, index)}
                              sx={{
                                padding: "4px",
                                "&:hover": { backgroundColor: "#f0f0f0" },
                              }}
                            >
                              <Icon
                                icon="mdi:dots-vertical"
                                width="18"
                                height="18"
                              />
                            </IconButton>

                            <Menu
                              anchorEl={anchorEl}
                              open={menuIndex === index}
                              onClose={handleMenuClose}
                              container={document.body}
                              disableScrollLock
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              PaperProps={{
                                sx: {
                                  borderRadius: "8px",
                                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                                  marginRight: "8px",
                                  overflow: "visible",
                                  maxHeight: "80vh",
                                },
                              }}
                              PopoverClasses={{
                                root: "menu-portal-root",
                              }}
                              slotProps={{
                                paper: {
                                  elevation: 3,
                                },
                              }}
                              PopoverProps={{
                                sx: {
                                  zIndex: 2000,
                                },
                                modifiers: [
                                  {
                                    name: "preventOverflow",
                                    enabled: true,
                                    options: {
                                      boundary: "viewport",
                                    },
                                  },
                                  {
                                    name: "flip",
                                    enabled: true,
                                    options: {
                                      altBoundary: true,
                                      rootBoundary: "viewport",
                                      padding: 8,
                                    },
                                  },
                                ],
                              }}
                            >
                              {/* {item.status === "REQUESTED" ? (
                                      <>
                                        <MenuItem
                                          onClick={handleMenuClose}
                                          sx={{ fontSize: "14px", py: "6px" }}
                                        >
                                          <Link
                                            to={`/EditCollectionTasks/${item.collection_id}`}
                                            style={{
                                              textDecoration: "none",
                                              color: "inherit",
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Icon
                                              icon="material-symbols:edit"
                                              width="18"
                                              height="18"
                                              style={{ marginRight: 8 }}
                                            />
                                            Edit
                                          </Link>
                                        </MenuItem>

                                        <MenuItem
                                          onClick={() => {
                                            handleMenuClose();
                                            setSelectedCollection(item);
                                            setSelectedIndex(index);
                                            setOpenDeleteDialog(true);
                                          }}
                                          sx={{ fontSize: "15px", py: "6px" }}
                                        >
                                          <Icon
                                            icon="mdi:trash"
                                            width="18"
                                            height="18"
                                            style={{
                                              marginRight: 8,
                                              color: "red",
                                            }}
                                          />
                                          Delete
                                        </MenuItem>
                                      </>
                                    )  */}
                              {item.status === "REQUESTED" ? (
                                <>
                                  <MenuItem
                                    component={Link}
                                    to={`/EditCollectionTasks/${item.collection_id}`}
                                    onClick={handleMenuClose}
                                    sx={{
                                      fontSize: "14px",
                                      py: "6px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <Icon
                                      icon="material-symbols:edit"
                                      width="18"
                                      height="18"
                                    />
                                    Edit
                                  </MenuItem>

                                  <MenuItem
                                    onClick={() => {
                                      handleMenuClose();
                                      setSelectedCollection(item);
                                      setSelectedIndex(index);
                                      setOpenDeleteDialog(true);
                                    }}
                                    sx={{
                                      fontSize: "15px",
                                      py: "6px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <Icon
                                      icon="mdi:trash"
                                      width="18"
                                      height="18"
                                      style={{ color: "red" }}
                                    />
                                    Delete
                                  </MenuItem>
                                </>
                              ) : (
                                <MenuItem
                                  onClick={handleMenuClose}
                                  sx={{ fontSize: "15px", py: "6px" }}
                                >
                                  <Link
                                    to={`/ecg-reports/${item.report_id}`}
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Icon
                                      icon="ion:reader"
                                      width="20"
                                      height="20"
                                      style={{ marginRight: 8 }}
                                    />
                                    View Report
                                  </Link>
                                </MenuItem>
                              )}
                            </Menu>
                          </RequireAuth>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>

                {isLoading && collectionData.length > 0 ? (
                  <Box textAlign="center" py={2}>
                    <CircularProgress size={20} />
                    <Typography variant="caption" ml={1}>
                      Loading more...
                    </Typography>
                  </Box>
                ) : !hasMore && collectionData.length > 20 ? (
                  <Box textAlign="center" py={2}>
                    <Typography variant="caption">No more tasks</Typography>
                  </Box>
                ) : null}
              </TableContainer>
            ) : (
              <BlankPreview
              sx={{ minHeight: "65vh" , marginTop:"20px" }}
                icon={nopreview}
                title="No Tasks Available"
                subtitle=""
              />
            )}
          </Box>
        </Box>
      </Box>
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        aria-labelledby="delete-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: "20px",
            padding: "0px",
            width: "508px",
            boxShadow: "var(--app-shadow)",
            position: "relative",
          },
        }}
      >
        {/* Close Icon */}
        <Icon
          icon="mdi:close"
          width="26"
          height="26"
          onClick={() => setOpenDeleteDialog(false)}
          style={{
            position: "absolute",
            right: 16,
            top: 16,
            cursor: "pointer",
            color: "#444",
          }}
        />

        {/* --------- TITLE + ICON --------- */}
        <DialogTitle
          id="delete-dialog-title"
          sx={{
            textAlign: "center",
            fontWeight: "700",
            fontSize: "22px",
            mb: 1,
            mt: 2,
          }}
        >
          <Box display="flex" flexDirection="column" alignItems="center">
            <Icon
              icon="mdi:alert"
              width="65"
              height="65"
              style={{ color: "#E04A3A", marginBottom: "12px" }}
            />
            Delete Collection Request?
          </Box>
        </DialogTitle>

        {/* --------- BODY TEXT --------- */}
        <DialogContent sx={{ px: 4 }}>
          <Typography
            align="center"
            variant="body1"
            sx={{
              color: "var(--app-text-muted)",
              fontSize: "16px",
              lineHeight: "1.6",
              mt: 1,
            }}
          >
            Are you sure you want to delete collection request{" "}
            <strong>#{selectedCollection?.collection_id}</strong>?
          </Typography>
        </DialogContent>

        {/* --------- ACTION BUTTONS --------- */}
        <DialogActions
          className="spn-model-btn"
          sx={{
            justifyContent: "center",
            mt: 1,
            gap: 2,
            pb: 2,
          }}
        >
          {/* Left Button – Light Red Like Your Ref UI */}
          <Button
            className="btn btn-added-danger"
            sx={{ boxShadow: "none" }}
            variant="contained"
            size="medium"
            onClick={() => {
              handleDelete(selectedCollection?.collection_id, selectedIndex);
              setOpenDeleteDialog(false);
            }}
          >
            Yes, Delete
          </Button>

          {/* Right Button – Purple */}
          <Button
            className="btn btn-added-primary"
            sx={{ boxShadow: "none" }}
            variant="contained"
            size="medium"
            onClick={() => setOpenDeleteDialog(false)}
          >
            No, Go Back
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function Filter({ handleFilter, collections = [] }) {
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useMemo(
    () =>
      debounce((val) => {
        handleFilter({ searchText: val });
      }, 400),
    [handleFilter],
  );

  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);

  return (
    <Box>
      <Grid
        container
        spacing={2}
        alignItems="center"
        sx={{
          mt: 2,
          flexWrap: { xs: "wrap", md: "nowrap" },
        }}
      >
        {/* Search Input */}
        <TextField
          variant="outlined"
          placeholder="Search by Collection ID, Phone number, Reference number"
          value={searchText}
          onChange={(e) => {
            const val = e.target.value;
            setSearchText(val);
            debouncedSearch(val);
          }}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "var(--app-text-muted)" }} />
              </InputAdornment>
            ),
            sx: {
              borderRadius: "8px",
              border: "1px solid var(--app-border)",
              backgroundColor: "var(--app-surface)",
              height: "45px",
              fontSize: "14px",
              "& fieldset": { border: "none" },
            },
          }}
        />

        {/* Create New Request Button */}
        <RequireAuth
          role={["b2b", "b2b-member", "b2b-admin"]}
          permission="canManageRequests"
        >
          <Button
            component={Link}
            to="/new-test-collection"
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() =>
              logAnalyticsEvent(
                ANALYTICS_EVENTS.NEW_TEST_COLLECTION_REQUEST_CLICKED
              )
            }
            sx={{
              backgroundColor: "#5751E9",
              fontSize: "14px",
              fontWeight: 600,
              textTransform: "none",
              height: "42px",
              borderRadius: "10px",
              whiteSpace: "nowrap",
              boxShadow: "none",
              fontFamily: "figtree",
              px: 5,
              "&:hover": {
                backgroundColor: "#433AC7",
                color: "white",
              },
            }}
          >
            New Test Collection
          </Button>
        </RequireAuth>
      </Grid>
    </Box>
  );
}
export default CollectionTasks;
